export default "__VITE_ASSET__4Ej6yPHJ__"